import React from 'react'
import MAIN_MENU, { activeMainMenu } from 'constants/menu/main-menu'
import {
  List,
  ListItem,
  MenuLink,
} from './styles'

export default function TopMenu() {
  const activeMenu = (match, location, area) => (
    activeMainMenu(match, location, area)
  )

  const renderMenuItem = (key) => {
    const item = MAIN_MENU[key]

    return (
      <ListItem key={`main-menu-${item.label}`}>
        <MenuLink
          exact={item.exact}
          to={item.link}
          activeClassName="active-main"
          isActive={(match, location) => activeMenu(match, location, key)}
        >
          {item.label}
        </MenuLink>
      </ListItem>
    )
  }

  return (
    <List>
      {Object.keys(MAIN_MENU).map(renderMenuItem)}
    </List>
  )
}
